import { OLAF } from 'HubStyleTokens/colors';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error not converted to TS

// @ts-expect-error not converted to TS
import { equals as areSimpleDatesEqual } from 'UIComponents/core/SimpleDate';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import UIFlex from 'UIComponents/layout/UIFlex';
import GroupedRevisionsSelect from 'automation-ui-canvas/containers/enrollment-history/panel/enrollments-list/GroupedRevisionsSelect';
import RevisionOptionComponent from 'automation-ui-canvas/containers/enrollment-history/panel/enrollments-list/RevisionOptionComponent';
import { FETCH_GROUPED_REVISIONS, GET_GROUPED_REVISIONS_FIELD } from 'automation-ui-canvas/containers/enrollment-history/panel/queries/revisionGroupingQueries';
import { getChangedActionsByVersion, getChangedActionsForVersionRange, getFilteredToGroupedRevisionOptions, getGroupedRevisionOptions } from 'automation-ui-canvas/containers/enrollment-history/utils/revisionFilterUtils';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import DateRangeFilter from 'automation-ui-management/components/filters/DateRangeFilter';
import { MAX_LOG_EVENT_RETENTION_DAYS } from 'automation-ui-management/constants/DataRetention';
import { ALL_PRESET_ID, CUSTOM_PRESET_ID } from 'automation-ui-management/constants/DateRangePickerOptions';
import { useApplicationHistoryFilters } from 'automation-ui-management/hooks/filterHooks';
import { getHistoryFiltersFromDateRange, makeDateRangeFromFilters } from 'automation-ui-management/records/ApplicationHistoryFilters/ApplicationHistoryFilterUtils';
import { toSimpleDate } from 'automation-ui-management/utils/dateRangeUtils';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import { useQuery } from 'data-fetching-client';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const LoadingSkeleton = () => /*#__PURE__*/_jsx(TFlex, {
  blockSize: "40px",
  align: "center",
  children: /*#__PURE__*/_jsx(SkeletonText, {
    backgroundColor: OLAF,
    width: 202
  })
});
const VersionAndDateFilterSection = ({
  flowId,
  page
}) => {
  var _paging$next;
  // Saving this to a ref to avoid infinite api calls because we are relying on current timestamp
  const startTimestamp = useRef(I18n.moment().subtract(MAX_LOG_EVENT_RETENTION_DAYS, 'days').valueOf());
  const history = useHistory();
  const trackEvent = useTrackEvent();
  const {
    search,
    pathname
  } = useLocation();
  const minMaxDatesRef = useRef([null, null]);
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const revisionStartTimestamp = searchParams.get('revisionStartTimestamp');
  const revisionEndTimestamp = searchParams.get('revisionEndTimestamp');
  const {
    filters,
    updateFilters
  } = useApplicationHistoryFilters();
  const dateRange = makeDateRangeFromFilters(filters);
  const {
    data: {
      [GET_GROUPED_REVISIONS_FIELD]: groupedRevisionsData = null
    } = {},
    loading,
    fetchMore
  } = useQuery(FETCH_GROUPED_REVISIONS, {
    variables: {
      flowId,
      startTimestamp: startTimestamp.current
    },
    fetchPolicy: 'network-only'
  });
  const {
    results: groupedRevisionResults,
    paging
  } = groupedRevisionsData !== null && groupedRevisionsData !== void 0 ? groupedRevisionsData : {};
  const updateVersionInfoOnUrl = ({
    startValue,
    endValue,
    version,
    clearActionFilter,
    changedActionsList
  }) => {
    if (startValue) {
      searchParams.set('revisionStartTimestamp', startValue.toString());
    }
    if (endValue) {
      searchParams.set('revisionEndTimestamp', endValue.toString());
    }
    if (version) {
      searchParams.set('version', version.toString());
    }
    if (changedActionsList) {
      searchParams.set('changedActions', changedActionsList.join(','));
    } else {
      searchParams.delete('changedActions');
    }
    // To clear the action filter when the from version is changed as the flow structure might have changed
    if (clearActionFilter) {
      searchParams.delete('actions');
    }
    history.replace({
      pathname,
      search: searchParams.toString()
    });
  };
  const fromGroupedRevisionOptions = useMemo(() => getGroupedRevisionOptions(groupedRevisionResults !== null && groupedRevisionResults !== void 0 ? groupedRevisionResults : []), [groupedRevisionResults]);
  const changedActionsByVersion = useMemo(() => getChangedActionsByVersion(groupedRevisionResults !== null && groupedRevisionResults !== void 0 ? groupedRevisionResults : []), [groupedRevisionResults]);
  const toGroupedRevisionOptions = useMemo(() => getFilteredToGroupedRevisionOptions(fromGroupedRevisionOptions !== null && fromGroupedRevisionOptions !== void 0 ? fromGroupedRevisionOptions : [], revisionStartTimestamp ? parseInt(revisionStartTimestamp, 10) : undefined), [revisionStartTimestamp, fromGroupedRevisionOptions]);
  useEffect(() => {
    if (!revisionStartTimestamp && !revisionEndTimestamp) {
      if (toGroupedRevisionOptions.length > 0) {
        const startRevisionOption = toGroupedRevisionOptions[toGroupedRevisionOptions.length - 1];
        const endRevisionOption = toGroupedRevisionOptions[1];
        updateVersionInfoOnUrl({
          startValue: startRevisionOption === null || startRevisionOption === void 0 ? void 0 : startRevisionOption.value,
          endValue: endRevisionOption === null || endRevisionOption === void 0 ? void 0 : endRevisionOption.endLimitTimestamp,
          version: endRevisionOption === null || endRevisionOption === void 0 ? void 0 : endRevisionOption.version,
          changedActionsList: getChangedActionsForVersionRange(changedActionsByVersion, startRevisionOption.version, endRevisionOption.version),
          clearActionFilter: true
        });
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [revisionEndTimestamp, revisionStartTimestamp, toGroupedRevisionOptions]);
  const updateDatesFromVersionTimestamps = useCallback((versionStartTimestamp, versionEndTimestamp) => {
    if (!versionStartTimestamp || !versionEndTimestamp) {
      return;
    }
    /*
    This is to make handle the scenario where the selected from version starts from a date before the min log retention day
    and we need to set the start date to the min log retention day. Because we need to show enrollment data from that point.
    */
    const startDateTimestamp = Math.max(parseInt(versionStartTimestamp, 10), startTimestamp.current);
    const currentStartDate = toSimpleDate(startDateTimestamp);
    const currentEndDate = toSimpleDate(parseInt(versionEndTimestamp, 10));
    if (!filters.getStartDate() || !areSimpleDatesEqual(toSimpleDate(filters.getStartDate()), currentStartDate) || !areSimpleDatesEqual(toSimpleDate(filters.getEndDate()), currentEndDate)) {
      minMaxDatesRef.current = [currentStartDate, currentEndDate];
      updateFilters(getHistoryFiltersFromDateRange({
        presetId: CUSTOM_PRESET_ID,
        startDate: currentStartDate,
        endDate: currentEndDate
      }));
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [fromGroupedRevisionOptions, toGroupedRevisionOptions]);
  useEffect(() => {
    if (loading || !!(dateRange !== null && dateRange !== void 0 && dateRange.startDate) || !!(dateRange !== null && dateRange !== void 0 && dateRange.endDate)) {
      return;
    }
    updateDatesFromVersionTimestamps(revisionStartTimestamp, revisionEndTimestamp);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [revisionEndTimestamp, revisionStartTimestamp, loading]);
  const getToValue = toRevisionEndLimitTimestamp => {
    let currentToOptionIndex = fromGroupedRevisionOptions.findIndex(option => option.endLimitTimestamp === toRevisionEndLimitTimestamp);
    // Handle the default load case
    if (currentToOptionIndex === -1) {
      currentToOptionIndex = 1;
    }
    return fromGroupedRevisionOptions[currentToOptionIndex].value;
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIFormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.enrollmentHistory.panel.enrollment-list.filter.revisionFilter.label"
      }),
      className: "m-bottom-2",
      children: /*#__PURE__*/_jsxs(UIFlex, {
        direction: "row",
        gap: 9,
        align: "center",
        children: [loading || !revisionStartTimestamp ? /*#__PURE__*/_jsx(LoadingSkeleton, {}) : /*#__PURE__*/_jsx(GroupedRevisionsSelect, {
          revisionOptions: fromGroupedRevisionOptions,
          value: parseInt(revisionStartTimestamp, 10),
          onChange: value => {
            var _currentToOption$endL, _currentToOption$endL2;
            const currentFromOption = fromGroupedRevisionOptions.find(option => option.value === value);
            // gets the index of current group header
            const currentGroupIndex = fromGroupedRevisionOptions.findIndex(option => option.groupId === currentFromOption.groupId && option.disabled);
            const currentToOption = fromGroupedRevisionOptions[currentGroupIndex + 1];
            trackEvent(Trackables.PERFORMANCE_HISTORY_FILTERS_VERSIONS, {
              subscreen: page
            });
            updateVersionInfoOnUrl({
              startValue: value,
              // Always sets the first option in the group as the end value
              endValue: currentToOption === null || currentToOption === void 0 ? void 0 : currentToOption.endLimitTimestamp,
              version: currentToOption === null || currentToOption === void 0 ? void 0 : currentToOption.version,
              changedActionsList: getChangedActionsForVersionRange(changedActionsByVersion, currentFromOption.version, currentToOption.version),
              clearActionFilter: true
            });
            updateDatesFromVersionTimestamps(value.toString(), (_currentToOption$endL = currentToOption === null || currentToOption === void 0 || (_currentToOption$endL2 = currentToOption.endLimitTimestamp) === null || _currentToOption$endL2 === void 0 ? void 0 : _currentToOption$endL2.toString()) !== null && _currentToOption$endL !== void 0 ? _currentToOption$endL : null);
          },
          fetchMore: fetchMore,
          hasMore: !!(paging !== null && paging !== void 0 && paging.next),
          offset: paging === null || paging === void 0 || (_paging$next = paging.next) === null || _paging$next === void 0 ? void 0 : _paging$next.after
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.enrollmentHistory.panel.enrollment-list.filter.revisionFilter.toDelimiter"
        }), loading || !revisionEndTimestamp ? /*#__PURE__*/_jsx(LoadingSkeleton, {}) : /*#__PURE__*/_jsx(UISelect, {
          buttonUse: "form-on-dark",
          optionComponent: RevisionOptionComponent,
          options: toGroupedRevisionOptions,
          value: getToValue(parseInt(revisionEndTimestamp, 10)),
          searchable: false,
          placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.enrollmentHistory.panel.enrollment-list.filter.revisionFilter.placeholder"
          }),
          onChange: evt => {
            var _currentToOption$endL3, _currentToOption$endL4;
            const value = parseInt(evt.target.value, 10);
            const currentToOption = fromGroupedRevisionOptions.find(option => option.value === value);
            const currentFromValue = parseInt(revisionStartTimestamp, 10);
            const currentFromOption = fromGroupedRevisionOptions.find(option => option.value === currentFromValue);
            trackEvent(Trackables.PERFORMANCE_HISTORY_FILTERS_VERSIONS, {
              subscreen: page
            });
            updateVersionInfoOnUrl({
              endValue: currentToOption === null || currentToOption === void 0 ? void 0 : currentToOption.endLimitTimestamp,
              version: currentToOption === null || currentToOption === void 0 ? void 0 : currentToOption.version,
              changedActionsList: getChangedActionsForVersionRange(changedActionsByVersion, currentFromOption.version, currentToOption.version)
            });
            updateDatesFromVersionTimestamps(revisionStartTimestamp, (_currentToOption$endL3 = currentToOption === null || currentToOption === void 0 || (_currentToOption$endL4 = currentToOption.endLimitTimestamp) === null || _currentToOption$endL4 === void 0 ? void 0 : _currentToOption$endL4.toString()) !== null && _currentToOption$endL3 !== void 0 ? _currentToOption$endL3 : null);
          }
        })]
      })
    }), /*#__PURE__*/_jsx(UIFormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.enrollmentHistory.panel.enrollment-list.filter.dateRangeWithinVersionsLabel"
      }),
      className: "m-bottom-2",
      children: loading || !revisionStartTimestamp ? /*#__PURE__*/_jsx(LoadingSkeleton, {}) : /*#__PURE__*/_jsx(DateRangeFilter, {
        dateRange: dateRange,
        min: minMaxDatesRef.current[0],
        max: minMaxDatesRef.current[1],
        onFilterChange: currentFilter => {
          const updatedHistoryFilter = currentFilter.rangeType === ALL_PRESET_ID ? getHistoryFiltersFromDateRange({
            presetId: CUSTOM_PRESET_ID,
            startDate: minMaxDatesRef.current[0],
            endDate: minMaxDatesRef.current[1]
          }) : currentFilter;
          updateFilters(updatedHistoryFilter);
        },
        shouldRenderFullComponent: true,
        trackingKey: Trackables.PERFORMANCE_HISTORY_FILTERS_DATE_RANGE_WITHIN_VERSIONS,
        clearLabel: I18n.text('automation.enrollmentHistory.panel.enrollment-list.filter.resetDateRange'),
        use: 'on-dark'
      })
    })]
  });
};
export default VersionAndDateFilterSection;